export { default } from './InfoContentIcon';
